import { createDirtyChecker, compareByPaths } from "../testNewForm/createDirtyChecker";
import { inputToGvc } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToGvc, compareByPaths({
    description: { path: "description" },
    locationItems: { path: "spec.staticPlacement.locationLinks", unordered: true },
    locationOptions: { path: "spec.staticPlacement.locationOptions", unordered: true, sortKey: "locationLink" },
    locationQuery: { path: "spec.staticPlacement.locationQuery" },
    pullSecretItems: { path: "spec.pullSecretLinks", unordered: true },
    endpointNamingFormat: { path: "spec.endpointNamingFormat" },
    tracing: { path: "spec.tracing" },
    sidecar: { path: "spec.sidecar" },
    env: { path: "spec.env" },
    loadBalancer: { path: "spec.loadBalancer" },
    keda: { path: "spec.keda" },
    tags: { path: "tags" },
  }));
}
